import React, { ReactNode, useRef } from "react";

import FlashPCBTooltip from "../../../common/FlashPCBTooltip";
import InfoIcon from "../../../common/FlashPCBTooltip/InfoIcon";

import {
  FlashPCBTable,
  TableHeaderCell,
  TableHeaderRow,
} from "../../../../constants/Styles";
import { HasInfoIcon } from "./ElementsTableStyles";
import HorizontalScroll from "../../../common/HorizontalScroll";
import { useAppSelector } from "../../../../utils/hooks/store";
import { ADMIN_GROUP, ENGINEER_GROUP } from "../../../../utils/group";

const HEADER_ROW_INFO = [
  {
    label: "",
    props: {
      width: "2rem",
    },
  },
  {
    label: "Reference designator",
    props: {
      width: "8rem",
    },
  },
  {
    label: "Count",
    props: {
      width: "6rem",
    },
  },
  {
    label: "Value Text",
    props: {
      width: "9rem",
    },
  },
  {
    label: "Footprint",
    props: {
      width: "10rem",
    },
  },
  {
    label: "Placement",
    props: {
      width: "12rem",
    },
  },
  {
    props: {
      width: "3rem",
    },
  },
  {
    props: {
      borderRight: true,
      width: "3rem",
    },
  },
  {
    label: "Selected part",
    props: {
      width: "15rem",
    },
  },
  {
    label: "Manufacturer",
    props: {
      width: "7rem",
    },
  },
  {
    label: "Part Description",
    props: {
      width: "16rem",
    },
  },
  {
    label: (
      <HasInfoIcon>
        Populate
        <FlashPCBTooltip content="Use this checkbox to select whether you would like this component on the board.">
          <InfoIcon />
        </FlashPCBTooltip>
      </HasInfoIcon>
    ),
    props: {
      width: "7rem",
    },
  },
  {
    label: (
      <HasInfoIcon>
        Consignment
        <FlashPCBTooltip content="Use this checkbox to select whether you would like to provide this part.">
          <InfoIcon />
        </FlashPCBTooltip>
      </HasInfoIcon>
    ),
    props: {
      width: "9rem",
    },
  },
  {
    label: "Actions",
    props: {
      width: "8rem",
    },
  },
];

const getTableMinorHeader = (
  forSpacing: boolean,
  isAdminOrEngineer: boolean,
) => {
  let HEADER_ROW_INFO_TO_DISPLAY = [];
  if (isAdminOrEngineer) {
    HEADER_ROW_INFO_TO_DISPLAY = [
      ...HEADER_ROW_INFO,
      {
        label: (
          <HasInfoIcon>
            Locked allocation
            <FlashPCBTooltip content="Use this checkbox to select whether the allocation for this part should be locked.">
              <InfoIcon />
            </FlashPCBTooltip>
          </HasInfoIcon>
        ),
        props: {
          width: "9rem",
        },
      },
    ];
  } else {
    HEADER_ROW_INFO_TO_DISPLAY = HEADER_ROW_INFO;
  }
  return (
    <TableHeaderRow style={{ visibility: forSpacing ? "collapse" : "visible" }}>
      {HEADER_ROW_INFO_TO_DISPLAY.map((rowInfo, index) => (
        <TableHeaderCell borderBottom key={index} {...rowInfo.props}>
          {rowInfo.label}
        </TableHeaderCell>
      ))}
    </TableHeaderRow>
  );
};

const ElementsTableWrapper = ({ children }: { children: ReactNode }) => {
  const tableRef = useRef<HTMLTableElement>(null);
  const { groups } = useAppSelector((state) => state.auth);
  const isAdminOrEngineer =
    groups.includes(ADMIN_GROUP) || groups.includes(ENGINEER_GROUP);
  return (
    <HorizontalScroll childrenRef={tableRef}>
      <FlashPCBTable ref={tableRef}>
        <thead>
          {getTableMinorHeader(true, isAdminOrEngineer)}
          <TableHeaderRow>
            <TableHeaderCell colSpan={8} borderBottom borderRight>
              Board elements info
            </TableHeaderCell>
            <TableHeaderCell colSpan={isAdminOrEngineer ? 7 : 6} borderBottom>
              Mark do not populate or select a part
            </TableHeaderCell>
          </TableHeaderRow>
          {getTableMinorHeader(false, isAdminOrEngineer)}
        </thead>
        <tbody>{children}</tbody>
      </FlashPCBTable>
    </HorizontalScroll>
  );
};

export default ElementsTableWrapper;
